import { fetchWrapper, objectToQueryParams } from '../utils';

export class admin {
  static baseUrl = process.env.REACT_APP_BASE_API + 'admin/maintenance-plan';

  static async create(form) {
    const url = `${this.baseUrl}`;
    return await fetchWrapper.post(url, form);
  }

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findOne(id) {
    const url = `${this.baseUrl}/${id}`;
    return await fetchWrapper.get(url);
  }

  static async update(form) {
    return await fetchWrapper.patch(this.baseUrl, form);
  }

  static async destroy(id) {
    const url = `${this.baseUrl}/${id}`;
    return await fetchWrapper.delete(url);
  }
}
